import ACTION_ITEMS from '../actionItems';

export function setPassport(passport) {
  return {
    type: ACTION_ITEMS.PASSPORT.RESULTS.SET,
    payload: { passport },
  };
}
